// extracted by mini-css-extract-plugin
export default {"subscriptionToast":"styles_subscriptionToast__K1gIP"};